module.exports = __webpack_public_path__ + "img/1.58d4fba7.jpg";